<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <Container
    :style="{ backgroundColor: blok?.backgroundColor ?? 'inherit' }"
    :default-padding="false"
    class="py-10"
    container-class="px-2.5 lg:px-10 2xl:px-20 md:px-5"
  >
    <div class="flex justify-start">
      <div v-editable="blok" class="flex xl:max-w-[1200px] w-full">
        <ColumnItem
          :blok="blok"
          is-full-column
          :font-style="blok.font"
          class="flex-1"
        />
      </div>
    </div>
  </Container>
</template>
